import { ContextConfig, ContextKey } from '../types';

export const CONTEXTS: Record<ContextKey, ContextConfig> = {
  EXAM: {
    zThresh: 2.0,
    sustainSec: 5,
    minChannels: 2,
    adjacentSec: 30,
    voicePct: 20,
    focusMin: 60,
    label: '시험',
  },
  QUIZ: {
    zThresh: 2.5,
    sustainSec: 8,
    minChannels: 2,
    adjacentSec: 30,
    voicePct: 25,
    focusMin: 50,
    label: '퀴즈',
  },
  PRACTICE: {
    zThresh: 3.0,
    sustainSec: 10,
    minChannels: 3,
    adjacentSec: 60,
    voicePct: 30,
    focusMin: 40,
    label: '연습',
  },
};
